var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row align-items-center mb-4"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"grey-box p-3 pt-4 pb-4"},[_c('BodyguardPriceList',{attrs:{"companyDetail":_vm.companyDetail}}),_c('VehiclePrice',{attrs:{"companyDetail":_vm.companyDetail}}),_c('EscortPrice')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }